/**
 * THEOplayer で MSE 再生に使えるのが ManagedMediaSource だけの端末 (iPhone / iPad) か。
 * MMS が使え、かつ MediaSource が無いか THEOplayer が iOS 端末とみなす端末が該当する。
 *
 * THEOplayer は iOS 端末では MediaSource があっても、source に useManagedMediaSource を
 * 指定しない限り MSE を使わずネイティブ再生する (lowLatency / liveOffset が効かない)。
 * iOS 端末の判定は THEOplayer と同じく、UA に iPhone / iPad / iPod を含むか、
 * UA が Mac かつタッチ対応 (デスクトップ表示の iPad) かで行う。
 */
export const isAvailableOnlyMms = (): boolean => {
  const { userAgent } = navigator;
  const isIOSDevice =
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (/Mac OS X|Macintosh/i.test(userAgent) && "ontouchstart" in window);
  return (
    "ManagedMediaSource" in window &&
    (!("MediaSource" in window) || isIOSDevice)
  );
};

/**
 * LL-HLS の再生に必要な MSE 系 API (MediaSource または ManagedMediaSource) が使えるか
 */
export const isAvailableMseOrMms = (): boolean => {
  return "MediaSource" in window || "ManagedMediaSource" in window;
};
